export const initialState = {
  responders: {}
};